import { AutogenModelCycle, AutogenRowCycle } from "./autogen/AutogenModelCycle";

export class ModelCycle extends AutogenModelCycle<RowCycle> {
	constructor() {
		super(RowCycle);
	}
}

export class RowCycle extends AutogenRowCycle {
}